let lenisInstance = null;

export const setLenis = (instance) => {
    lenisInstance = instance;
};

export const scrollTop = () => {
    if (lenisInstance) {
        lenisInstance.scrollTo(0, { immediate: true });
    } else {
        window.scrollTo(0, 0);
    }
};

export const scrollToId = (id) => {
    if (lenisInstance) {
        lenisInstance.scrollTo(id, { offset: -72, duration: 1.4 });
    } else {
        document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });
    }
};
